import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import type { RumViewName } from './datadogRum';
import { rumStartView } from './datadogRum';

// Most-specific-first so overlay routes win over base routes; matching is exact.
const ROUTE_VIEW_MAP: readonly { pattern: string; view: RumViewName }[] = [
  { pattern: '/team/invite', view: 'team_invite' },
  { pattern: '/team/member/:user_uuid', view: 'team_member' },
  { pattern: '/team', view: 'team' },
  { pattern: '/activity', view: 'activity' },
  { pattern: '/security/approval-rules', view: 'security_approval_rules' },
  { pattern: '/security', view: 'security' },
  { pattern: '/approvals', view: 'approvals' },
];

export function getRumViewName(pathname: string): RumViewName | undefined {
  const match = ROUTE_VIEW_MAP.find(({ pattern }) => matchPath({ path: pattern }, pathname));
  return match?.view;
}

// Replace dynamic path segments (e.g. /team/member/<uuid>) with their route
// pattern (/team/member/:user_uuid) so identifiers never reach Datadog.
export function normalizeRumPath(pathname: string): string {
  const match = ROUTE_VIEW_MAP.find(({ pattern }) => matchPath({ path: pattern }, pathname));
  return match ? match.pattern : pathname;
}

// Mount once inside the router so every navigation maps to a named, PII-free view.
export function useRumViewTracking(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    const view = getRumViewName(pathname);
    if (view) {
      rumStartView(view);
    }
  }, [pathname]);
}
